module.exports = __webpack_public_path__ + "assets/images/EUR010.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/EUR010.png
// module id = 1359
// module chunks = 1